import React, {Component} from "react"
import * as PropTypes from "prop-types"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import platformTracking from "@irati-tracking/platform"
import Link, {RouterLink} from "@irati/ui/src/Link"
import {walletTracking} from "@irati-tracking/wallet"

import authentication from "@irati/auth"
import SwitchAccount from "../../../../SwitchAccount"
import UserWallet from "../../../desktop/WalletMenu/UserWallet"
import UserMenuContext from "../../../shared/UserMenuContext"
import DealsMenuLink from "../../../shared/userMenuContexts/Deals"

interface Props extends InjectIntl {
  id?: string
}

interface State {
  height: number
  showWallet: boolean
}

class MenuContext extends Component<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    app: PropTypes.string.isRequired,
    appPath: PropTypes.string.isRequired
  }

  state: State = {
    height: 0,
    showWallet: false
  }

  render() {
    const {formatMessage} = this.props
    const {apps, appPath} = this.context
    const idNamespace = id("user-menu", this.props)
    const {ACCOUNT, ADMIN, PLATFORM} = apps

    const showUserCurrencyWallet = authentication.apps("wallet.users")
    const showPerkPoints = authentication.apps("wallet.treatTokens")

    return (
      <>
        {(showUserCurrencyWallet || showPerkPoints) && (
          <UserWallet
            id={idNamespace}
            onClick={() => walletTracking.clickWalletBalance(this.context.app, 0, "", "profileDropdown")}
            text="platform.wallet.menu.user.title"
          />
        )}
        <UserMenuContext id={idNamespace} />

        {appPath !== ADMIN && (authentication.apps("perks") || authentication.apps("wallet.flexiRewards.view")) && <DealsMenuLink />}

        {appPath !== ACCOUNT && (
          <>
            <RouterLink
              plain
              id={id("link-profile", idNamespace)}
              to="/"
              onClick={() => platformTracking.clickHeaderMyAccount({source: window.location.href})}
              app={ACCOUNT}>
              <FormattedMessage id="platform.userMenu.header.account" />
            </RouterLink>
            <Link id={id("link-help", idNamespace)} target="_blank" plain href={formatMessage({id: "platform.help.header.href"})}>
              <FormattedMessage id="platform.help.header.text" />
            </Link>
          </>
        )}
        <RouterLink id={id("link-logout", idNamespace)} plain to="/welcome/logout" app={PLATFORM}>
          <FormattedMessage id="platform.userMenu.link.logout" />
        </RouterLink>
        <SwitchAccount />
      </>
    )
  }
}

export default injectIntl(MenuContext)
